export default "__VITE_ASSET__RfwpejC7__"